
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/edition/[category]",
      function () {
        return require("private-next-pages/[lang]/edition/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/edition/[category]"])
      });
    }
  